import api from '../utils/api';

export const getPermissions = async () => {
  const { data } = await api.get('/api/rbac/permissions');
  return data;
};

export const getRoles = async () => {
  const { data } = await api.get('/api/rbac/roles');
  return data;
};

export const getRolePermissions = async (role) => {
  const { data } = await api.get(`/api/rbac/roles/${encodeURIComponent(role)}/permissions`);
  return data; // [{ permissionId, key, effect }]
};

export const setRolePermissions = async (role, items) => {
  const { data } = await api.put(`/api/rbac/roles/${encodeURIComponent(role)}/permissions`, items);
  return data;
};

export const getUserOverrides = async (userId) => {
  const { data } = await api.get(`/api/rbac/users/${userId}/overrides`);
  return data; // [{ permissionId, key, effect }]
};

export const setUserOverrides = async (userId, items) => {
  const { data } = await api.put(`/api/rbac/users/${userId}/overrides`, items);
  return data;
};

export const getMyAbilities = async () => {
  const { data } = await api.get('/api/rbac/me/abilities');
  return data; // { key: boolean }
};

export const syncPermissions = async (defs) => {
  const { data } = await api.post('/api/rbac/sync', defs);
  return data;
};


